import {
  ApplicationConfig,
  ErrorHandler,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';
import { es } from 'primelocale/es.json';

import { routes } from './app.routes';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
import { authInterceptor } from './auth/interceptors/auth.interceptor';
import { sessionInterceptor } from './shared/interceptors/session.interceptor';
import { GlobalErrorHandler } from './shared/services/global-error-handler';
import { MessageService } from 'primeng/api';
import { provideEchartsCore } from 'ngx-echarts';

ModuleRegistry.registerModules([AllCommunityModule]);

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{teal.50}',
      100: '{teal.100}',
      200: '{teal.200}',
      300: '{teal.300}',
      400: '{teal.400}',
      500: '{teal.500}',
      600: '{teal.600}',
      700: '{teal.700}',
      800: '{teal.800}',
      900: '{teal.900}',
      950: '{teal.950}',
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withComponentInputBinding()),
    provideAnimationsAsync(),
    provideHttpClient(
      withFetch(),
      withInterceptors([sessionInterceptor, authInterceptor])
    ),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: { darkModeSelector: '.dark' },
      },
      translation: es,
    }),
    { provide: LOCALE_ID, useValue: 'es-CO' },
    MessageService,
    provideEchartsCore({ echarts: () => import('echarts') }),
  ],
};
